import { Flex } from '../UI/Flex/Flex';
import {
    useStore,
    useStoreUI,
    useClientSettingStore
} from '@assets/model/Store';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { DataAccessUtils } from '../../model/DataAccessUtils';
import * as style from './DealModalSearchContent.module.less';
import { DealModalSearchHeader } from './DealSearchHeader/DealModalSearchHeader';
import { DealModalThumbnail } from './DealThumbnail/DealModalThumbnail';

interface DealModalSearchContentProps {
    onDealSelect?: (dealId: string) => void;
    excludeDeals?: string[];
}

export const DealModalSearchContent = observer(
    (props: DealModalSearchContentProps) => {
        const store = useStore();
        const uiStore = useStoreUI();
        const clientStore = useClientSettingStore();
        const excludeDeals = props.excludeDeals || [];

        useEffect(() => {
            uiStore.dealPageIndustrySearch = [];
            uiStore.dealPageNameSearch = '';
        }, []);

        const dealKeys = Object.keys(store.reportDataDB);
        var filtered = dealKeys.filter(deal => {
            // Filter out excluded deals (active company and already selected companies)
            if (excludeDeals.includes(deal)) {
                return false;
            }

            var e = store.reportDataDB[deal];
            if (e.status != 'completed') {
                return false;
            }

            // Apply demo filter
            const filter_settings = clientStore.filterCompaniesForDemo;
            if (clientStore.isDemoFilterOn && filter_settings != null) {
                if (filter_settings[deal] !== true) {
                    return false;
                }
            }

            var dataAccess = store.createDataAccess(deal);
            const companyName = dataAccess.companyName;
            const matchCompanyName =
                companyName
                    .toLowerCase()
                    .includes(uiStore.dealPageNameSearch.toLowerCase()) ||
                uiStore.dealPageNameSearch == '';

            const filter = uiStore.dealPageIndustrySearch;
            var industry = dataAccess.value('industry');
            var sub_industry = dataAccess.value('industrySubType');
            if (!dataAccess.report_has_pdf) {
                return false;
            }

            var matchIndustry = false;
            if (filter.length == 0) {
                matchIndustry = true;
            } else {
                filter.forEach(filterItem => {
                    if (filterItem.type == 'category') {
                        if (filterItem.value == industry) {
                            matchIndustry = true;
                        }
                    } else if (filterItem.type == 'sub_category') {
                        if (filterItem.value == sub_industry) {
                            matchIndustry = true;
                        }
                    }
                });
            }

            return matchCompanyName && matchIndustry;
        });

        filtered = filtered.sort((a, b) => {
            const aName = store.reportDataDB[a].company_name;
            const bName = store.reportDataDB[b].company_name;
            return aName.localeCompare(bName);
        });

        const deals = filtered.map(deal => (
            <DealModalThumbnail
                key={deal}
                name={deal}
                onSelect={props.onDealSelect}
            />
        ));

        return (
            <Flex direction="column" className={style.container}>
                <DealModalSearchHeader />
                <div className={style.dealsList}>
                    {deals.length > 0 ? (
                        deals
                    ) : (
                        <div className={style.noDealsMessage}>
                            No available deals to select
                        </div>
                    )}
                </div>
            </Flex>
        );
    }
);
